import { useCallback, useEffect, useState } from "react";
import Errors from "../../models/errors";
import Document from "../../models/document";
import DocumentSelect from "../document/DocumentSelect";
import { CButton, CButtonGroup, CInput, CTooltip } from "@coreui/react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface BarcodeItemFormProps {
  value?: Document;
  initialValue?: Document;
  initialErrors?: Errors;
  sizesColumns: string[];
  errors: Errors;
  disabled?: boolean;
  onChange: (document: Document) => void | Promise<void>;
  onDelete: (saleOrderItem: Document) => void | Promise<void>;
}

const BarcodeItemForm: React.FC<BarcodeItemFormProps> = ({
  value,
  initialErrors,
  sizesColumns,
  initialValue,
  onChange,
  onDelete,
  errors,
  disabled,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);

  const [editingItem, setEditingItem] = useState<Document>(value ? value : {});

  const [, setTotalRequiredClothesAmount] = useState<number>(0);

  const onDocumentChange = useCallback(
    (newDocument: Document | null) => {
      const newItem = {
        ...(newDocument !== null ? newDocument : {}),
      };
      setEditingItem(newItem);
      setTotalRequiredClothesAmount(1);
      onChange(newItem);
    },
    [editingItem, company.id, onChange]
  );

  const onDeleteClick = useCallback(() => {
    onDelete(editingItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem, onDelete]);

  useEffect(() => {
    setEditingItem(value ? value : {});
  }, [value]);

  return (
    <tr style={{ verticalAlign: "middle", overflow: "hidden" }}>
      <td style={{ padding: 0, minWidth: "200px" }}>
        <DocumentSelect
          value={
            editingItem && editingItem.id !== undefined ? editingItem : null
          }
          onChange={onDocumentChange}
          disabled={disabled}
        ></DocumentSelect>
      </td>
      <td className="text-center" style={{ padding: 0, width: "60px" }}>
        <CButtonGroup>
          <CTooltip content="Borrar">
            <CButton
              className="text-white"
              color="danger"
              onClick={() => {
                onDeleteClick();
              }}
              disabled={disabled}
            >
              <i className="fa fa-trash"></i>
            </CButton>
          </CTooltip>
        </CButtonGroup>
      </td>
    </tr>
  );
};

export default BarcodeItemForm;
